<div class="container">

  <div class="title-container">
    <div class="vox-heading-3" translate>connectivity.edit-modal.title</div>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <i class="icon-small-close"></i>
    </button>
  </div>
  <div class="form">
    <gdp-connectivity-entry-form (valueChanges)="onValueChanges($event)" [data]="entryToEdit"></gdp-connectivity-entry-form>
  </div>
  <div class="actions-container">
    <button class="vox-btn vox-btn-secondary" [disabled]="!currentFormValue?.isValid" (click)="submit()" translate>common.save</button>
  </div>
</div>
